import { Injectable } from '@angular/core';

@Injectable()
export class ReportItemModel {

    public id: string;
    public title: string;
    public filters: Array<any>;
    public type: string;
    public columns: Array<any>;
    public charts: Array<any>;
    public children: ReportItemModel;
    public implicitFilter: Array<any>;


    public constructor(obj: any) {
        for (let key in obj) {
            this[key] = obj[key];
        }

    }
}